import axios from 'axios';
import { cachetime } from '../config';

const mainlandImages = {
  __proto__: null,
  weibo: '/static/images/common/weibo.jpg',
  weixin: '/static/images/common/weixin.jpg',
  xiaohongshu: '/static/images/common/xiaohongshu.jpg'
};

const shuffleArray = function(array) {
  for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
  }
}

export default function() {
  return {
    namespaced: true,
    state: {
      feeds: {},
      subscriptions: {}
    },
    mutations: {
      RESET_FEED(state, {locale}) {
        state.feeds[locale] = {}; 
      },
      UPDATE_FEED(state, { key, data, locale }) {
        const existData = (state.feeds && state.feeds[locale]) || {};
        const existKeyData = existData[key] || [];

        state.feeds = {
          ...state.feeds,
          [locale]: {
            ...existData,
            [key]: [...existKeyData, data],
            __updatedAt: Date.now()
          }
        }
      },
      UPDATE_SUBSCRIPTION(state, { data, locale }) {
        state.subscriptions = {
          ...state.subscriptions,
          [locale]: {
            data,
            __updatedAt: Date.now()
          }
        }
      },
    },
    actions: {
      FETCH_FEED({ state, rootState, commit }, { locale }) {
        if (state.feeds[locale] && Date.now() - state.feeds[locale].__updatedAt < cachetime) return;
          commit('RESET_FEED', { locale });
          if (locale === 'zh-hans' && rootState.previewProfile === 'staging') {
            return axios.get('/api/curator/mainland-marketing').then(({ data }) => {
              for (const [key, group, size, limit] of [
                ['infoFeeds', 'mainland_marketing', 3, 3],
                ['imgFeeds', 'mainland_douyin', 6, 12]
              ]) {
                const items = data?.groups?.find(item => item.key === group)?.items;
                if (!Array.isArray(items)) continue;

                const feeds = items.filter(feed => typeof feed?.url === 'string' && /^https:\/\//i.test(feed.url))
                  .map((feed, index) => ({
                    id: feed.id ?? `${group}-${index}`,
                    network_id: feed.platformCode,
                    network_name: feed.platformLabel,
                    user_full_name: feed.platformLabel,
                    url: feed.url,
                    text: typeof feed.content === 'string' ? feed.content : '',
                    image: mainlandImages[feed.platformCode] ||
                      (typeof feed.thumbnailUrl === 'string' && /^https:\/\//i.test(feed.thumbnailUrl) ? feed.thumbnailUrl : ''),
                    video: key === 'imgFeeds' ? feed.url : ''
                  }));
                shuffleArray(feeds);

                for (let offset = 0; offset < Math.min(feeds.length, limit); offset += size) {
                  const batch = feeds.slice(offset, offset + size);
                  commit('UPDATE_FEED', {
                    key,
                    locale,
                    data: { id: `${group}#${offset}`, pageUrl: batch[0].url, feeds: batch }
                  });
                }
              }
            }).catch(error => console.log(error));
          }
          axios.get(encodeURI(`/api/socialmedia/feed`)).then((res) => {
            let data = res.data || {};

            let infoFeed = data.infoFeeds || [];
            let imgFeed = data.imgFeeds || [];

            const updateFeed = async (key, id, count) => new Promise(async (resolve, reject) => {
              let res = { data: { } }

              try {
                res = await axios.get(`/api/curator/v1/feeds/${id}/posts?limit=10`);
              } catch (error) {
                resolve();
              }

              let feeds = ((res 
                && res.data
                && res.data.posts) 
                  ? res.data
                  : {posts: []}).posts;

              const isPinterest = res.data.networks[0] == 4;
              const isRSS = res.data.networks[0] == 10;

              if (key == 'infoFeeds') {
                // RSS will skipp image checking
                feeds = feeds.filter(feed => (feed.text && feed.text.length > 0 && (!!feed.image || isRSS)) && !(feed.is_repost == 1 && feed.network_id == 1))
              }

              /**
               * TODO: Load the image here by axios check
               */

              let results = [];
              if (feeds.length >= count) {
                const checkImageValid = async (path) => {
                  const loadImage = (path) => new Promise((r) => {
                    const img = new Image();
                    img.onload = () => r(true);
                    img.onerror = () => r(false);
                    img.src = path;
                  })
                  try {
                    return await loadImage(path);
                  } catch (error) {
                    return false;
                  }
                }

                let idx = -1;
                while (results.length < count && idx + 1 < feeds.length) {
                  idx = idx + 1;
                  let imageExist = !!feeds[idx].image && await checkImageValid(feeds[idx].image);
                  console.log('[SNS] Checked feeds', feeds[idx], imageExist);
                  (imageExist || isRSS) && results.push(feeds[idx]);
                }

                if (results.length == count) {
                  // GET page url
                  const pageUrl = isPinterest
                    ? `https://www.pinterest.com/${res.data.sources[0].name}`
                    : results[0].user_url
                  commit('UPDATE_FEED', { 
                    key,
                    locale,
                    data: {
                      id,
                      pageUrl,
                      feeds: results.map(r => ({
                        ...r,
                        url: isPinterest
                          ?`https://www.pinterest.com/pin/${r.source_identifier}` 
                          : r.url
                      }))
                    }, 
                  });
                }
              } 

              resolve();
            })

            shuffleArray(infoFeed);
            shuffleArray(imgFeed);

            (async () => {
              if (infoFeed.length > 0) {
                await updateFeed('infoFeeds', infoFeed[0], 3);
                for (let i = 1; i < infoFeed.length; i++) {
                  updateFeed('infoFeeds', infoFeed[i], 3); 
                }
              }
              if (imgFeed.length > 0) {
                await updateFeed('imgFeeds', imgFeed[0], 6); 
                for (let i = 1; i < imgFeed.length; i++) {
                  updateFeed('imgFeeds', imgFeed[i], 6);               
                }
              }
            })()
            
          }).catch((err) => {
            console.log(err);
          });          
      },
      FETCH_SUBSCRIPTION({ state, commit }, { locale }) {
        if (state.subscriptions[locale] && Date.now() - state.subscriptions[locale].__updatedAt < cachetime) return;
        return axios.get(encodeURI(`/api/socialmedia/subscription`))
          .then((res) => {
            let data = res.data;
            if (!Array.isArray(data)) {
              data = [];
            }
            
            commit('UPDATE_SUBSCRIPTION', { data, locale });
          }).catch(err => console.log(err));      
      },
    },
    getters: { 
      getFeed: (state) => (locale) => {
        return state.feeds[locale] || {};
      },
      getSubscription: (state) => (locale) => {
        return (state.subscriptions[locale] && state.subscriptions[locale].data) || [];
      }
    }
  }
}